import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExecuteChangeServerResponse } from 'src/app/firm-settings/bulk-handling/interfaces/bulk-change.component';
import { BLService } from './bl.service';

@Injectable()
export class BulkService extends BLService {
  private RESOURCE_ENDPOINT = 'bulk-change';

  change(data: any): Observable<ExecuteChangeServerResponse> {
    const options = this.httpAuthHeader.getHeaderWithoutContentType();
    // const data = {
    //   actionType: 'CHANGE_RESPONSIBLE_USER',
    //   changes: [],
    //   rows: [],
    // };
    return this.httpPut<ExecuteChangeServerResponse>(this.RESOURCE_ENDPOINT, data, options);
  }
}
